$(document).ready(() => {
	const html = $('html');
	const search = $('.search');
	const input = search.find('.input');
	const button = search.find('.button');
	const cancel = search.find('.cancel');

	let scrollPosition = null;

	const setCondition = e => {
		const current = $(e.currentTarget);
		const parent = current.parents('.search');
		const value = current.val();

		if (value) {
			parent.removeClass('disabled');
		} else {
			parent.addClass('disabled');
		}
	};

	input.on('focus', e => {
		setCondition(e);
	});

	input.on('input', e => {
		setCondition(e);
	});

	input.on('blur', e => {
		setTimeout(() => {
			const current = $(e.currentTarget);

			current.val('');
			current.parents('.search').removeClass('disabled');
		}, 500)
	});

	button.on('click', e => {
		const current = $(e.currentTarget);
		const parent = current.parents('.search');

		if ($(window).width() < 960 && !parent.hasClass('opened')) {
			parent.addClass('opened');

			scrollPosition = html.scrollTop();

			html.css({
				position: 'fixed',
				top: 0,
				left: 0,
				bottom: 0,
				right: 0,
				overflow: 'hidden'
			});
		} else {
			const cInput = parent.find('.input');

			if (cInput.val()) {
				window.location = `/search.html?search=${cInput.val()}`;
			}
		}
	});

	cancel.on('click', e => {
		const current = $(e.currentTarget);
		const parent = current.parents('.search');
		const cInput = parent.find('.input');

		html.removeAttr('style');
		html.scrollTop(scrollPosition);

		cInput.val('').blur();

		html.focus();

		parent.removeClass('opened disabled');
	});
});
